import { MopedIcon } from './MopedIcon';

/**
 * author: Google
 * id DC294862-E625-444E-83A4-7D5F2255EE0C
 * name moped
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/moped.svg
 * tags
 * - Transportation + Road 
 * - Transportation + Other 
 */
export const VespaIcon = MopedIcon;
export default VespaIcon